import { render, staticRenderFns } from "./edrawing.vue?vue&type=template&id=22825736&scoped=true&"
import script from "./edrawing.vue?vue&type=script&lang=js&"
export * from "./edrawing.vue?vue&type=script&lang=js&"
import style0 from "./edrawing.vue?vue&type=style&index=0&id=22825736&scoped=true&lang=css&"
import style1 from "./edrawing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22825736",
  null
  
)

export default component.exports